import type { ISwSettings } from "app/@types/ISwSettings";
import { EHooksVersions } from "app/services/SwHook";

import { isDMIAfterTrial, isMcpNtOrTrialOrAfterTrial, isNoTouch } from "./usersUtils";

export const getHooksVersion = (swSettings: ISwSettings): EHooksVersions =>
    (isDMIAfterTrial(swSettings) || isNoTouch(swSettings)) && !isMcpNtOrTrialOrAfterTrial(swSettings)
        ? EHooksVersions.V6
        : EHooksVersions.V5;
